<template>
    <div class="SimplifiedHeader">
        <a 
            :href="baseUrl" 
            title="Retourner sur le site monchauffagisteprivé"
            class="redirect-link"
        >
            <img :src="`${mediaBaseUrl}logo.svg`" class="mcp-logo">
        </a>

        <!-- Verified Reviews -->
        <VerifiedReviews 
            v-if="verifiedReviewsDatas.display == '1'"
            :verifiedReviewsDatas="verifiedReviewsDatas"
            :baseUrl="baseUrl"
        ></VerifiedReviews>
    </div>
</template>

<script>
import InstanceApi from "@/services/apiClient.js";

import VerifiedReviews from '@/includes/Header/VerifiedReviews/VerifiedReviews.vue';


export default {
    name: "SimplifiedHeader",

    components: { 
        VerifiedReviews,
    },

    data() {
        return {
            baseUrl: process.env.VUE_APP_API_BASE_URL,
            mediaBaseUrl: `${process.env.VUE_APP_API_BASE_URL}/skin/frontend/mcp/default/images/`,
            verifiedReviewsDatas: {},
        };
    },

    methods: {
        async fetchReviewDatas() {
            const response = await InstanceApi.get("mcp/header/getReviews/");
            this.verifiedReviewsDatas = response.data.components.verified_reviews;
        },
    },

    created() {
        this.fetchReviewDatas();
    },
    
}
</script>

<style lang="scss">
.SimplifiedHeader {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 28px;
    
    .redirect-link {
        display: block;
    }

    .mcp-logo {
        width: 200px;

        @include breakpoint(md) {
            width: auto;
        }
    }

    .VerifiedReviews__container {
        display: none;
    }
}


// Tablet 640px
.SimplifiedHeader {
    @include breakpoint(sm) {
        padding: 0px 28px;

        .redirect-link {
            margin: 20px 0;
        }

        .VerifiedReviews__container {
           display: flex; 
        }
    }   
}

</style>